/**
 * Get the first site and program in the programEnrollment section of the store.
 * @returns {object} An object of the form { siteId: firstSiteId, programId : firstProgramId }
 */
export function getFirstSiteAndFirstProgram( programEnrollment ) {
  // find the first possible site
  var firstSiteId = null;
  var firstProgramId = null;
  if ( programEnrollment && programEnrollment.enrollment && programEnrollment.enrollment.sites && programEnrollment.enrollment.sites[0]) {
    // find the first possible program

    var firstSite = programEnrollment.enrollment.sites[0];
    firstSiteId = firstSite.siteId;
    if ( firstSite.programs && firstSite.programs[0]) {
      var firstProgram = firstSite.programs[0];
      firstProgramId = firstProgram.programId;
    }

    if (firstSiteId != null && firstProgramId != null) {
      return { siteId: firstSiteId, programId : firstProgramId };
    }

    return null;
  }
}

/**
 * fetch the form's participant portal alias or external name if no alias given
 * @param {*} programEnrollment the store object
 * @param {string} siteId guid for the site
 * @param {string} programId guid for the program
 * @param {string} formId guid for the form/touchpoint
 * @returns {string} alias if it exists, or external name if it doesn't, or empty string if not found
 */
export function getFormAlias( programEnrollment, siteId, programId, formId) {
  if ( programEnrollment && programEnrollment.enrollment && programEnrollment.enrollment.sites) {
    if(siteId === null || programId === null || formId === null)
      return '';

    var site, program, form;
    site = programEnrollment.enrollment.sites.find(s => s.siteId === siteId);
    if (!site)
      return '';
    program = site.programs.find(p => p.programId === programId);
    if (!program)
      return '';
    form = program.formPermissions.find(f => f.touchpointId === formId);
    if (!form)
      return '';

    return !form.alias ? form.externalName : form.alias;
  }
  return '';
}

/**
 * returns a list of forms available to the participant to fill out
 * @param {*} programEnrollment the store object
 * @param {string} siteFilter (optional) string identifier of the site to restrict form results to
 * @param {string} programFilter (optional) string identifier of the program to restrict form results to
 * @returns {array} list of all enabled forms with add permission granted
 */
export function getFormsWithAddPermission(programEnrollment, siteFilter = null, programFilter = null) {
  const { enrollment } = programEnrollment || {};
  const { sites } = enrollment || { sites: [] };

  var forms = [];
  var validProgramForms;
  sites.forEach(site => {
    if(!siteFilter || siteFilter === site.siteId) {
      site.programs.forEach(program => {
        if(!programFilter || programFilter === program.programId) {
          validProgramForms = program.formPermissions.filter(form => form.addPerm && form.enabled);
          forms = forms.concat(validProgramForms);
        }
      })
    }
  });
  return forms;
}

/**
 * gets the program name based on the program Id
 * @param {*} programEnrollment the store object
 * @param {string} programId id of the program
 */
export function getProgramName(programEnrollment, programId) {
  const { enrollment } = programEnrollment || {};
  const { sites } = enrollment || { sites: [] };

  const site = sites.find(s => s.programs && s.programs.some(p => p.programId === programId));
  if(site){
    const program = site.programs.find(p => p.programId === programId);
    return program && program.name ? program.name : "";
  }

  return "";
}

/**
 * gets the site name based on the site Id
 * @param {*} programEnrollment the store object
 * @param {string} site id of the site
 */
export function getSiteName(programEnrollment, siteId) {
  const { enrollment } = programEnrollment || {};
  const { sites } = enrollment || { sites: [] };

  const site = sites.find(s => s.siteId === siteId);
  if(site){
    return site.name ? site.name : "";
  }

  return "";
}



// WEBPACK FOOTER //
// src/common/program-enrollment-utilities.js